<template>
<div class="chapter">
<div class="inner_page">
<h1 class="chapter-number"><span><a href="#/toc#toc-chapter006">SIX</a></span></h1>
<h1 id="a001">TUESDAY, SEPTEMBER 2, 2008</h1>
<p class="noindent"><a id="page-22">‘Why did you become a cop, Frank?’</a></p><a id="page-22">
<p>‘Why did you become a shrink?’</p>
<p>‘I’m not comfortable with that term.’</p>
<p>‘Like I’m comfortable with being called a cop?’</p>
<p>‘Okay … why did you become a police officer?’</p>
<p>‘Why did you become a headpeeper?’</p>
<p>‘Very good, Frank. You seriously want to spend the next month playing games every day?’</p>
<p>‘No, not really. I want to spend the next month solving murders.’</p>
<p>‘Well, be that as it may, Frank, the fact is that unless you continue to see me on a regular basis then you’re going to be suspended. That means either you can see me and continue to work, or you can refuse to see me and stay home. Which is it going to be?’</p>
<p>‘The first one.’</p>
<p>‘Good. So – I’m going to put my cards on the table. The particular aspect of therapy that I focus on relates, in the main, to parental relationships. We all know who your father was. We know his record and his achievements, and we know that he was a significant figure in your early life. This is something I want particularly to address with you.’</p>
<p>‘You want me to talk about my father?’</p>
<p>‘I do.’</p>
<p>‘What if I want to talk about my mother?’</p>
<p>‘Then there will be an opportunity to do so but, in the first instance, I will acknowledge you politely and ask you to talk about your father.’</p>
<p>‘Seriously?’</p>
<p>‘Seriously.’</p>
</a><p><a id="page-22"></a><a id="page-23">‘You don’t want to know about my father.’</a></p><a id="page-23">
<p>‘Yes I do, Frank, I want to know everything you remember about him.’</p>
<p>‘And you think this will have some value to me?’</p>
<p>‘I do.’</p>
<p>‘Well <em>I</em> can tell <em>you</em> it won’t.’</p>
<p>‘Naturally, I can’t force you to talk about him, but I must stress that progress along that line will be my main interest.’</p>
<p>‘And I will acknowledge you politely, and then tell you to go fuck yourself.’</p>
<p>‘Okay, let’s start somewhere else. Tell me why you became a police officer?’</p>
<p>‘So I could find out all the things that my father never told me.’</p>
<p>‘Go on.’</p>
<p>‘Okay, Doctor Griffin … Marie … you don’t mind if I call you Marie …You <em>really</em> want to know about him?’</p>
<p>‘Yes.’</p>
<p>‘Well, my old man was a ballbreaker. He was OCCB.’</p>
<p>‘OCCB?’</p>
<p>‘Organized Crime Control Bureau. He was there when they got The Cigar in 1979.’</p>
<p>‘The Cigar?’</p>
<p>‘A nickname. That’s what they called Carmine Galante, ’cause he always had a cigar in his mouth. Even when he was shot dead he had a fucking cigar in his mouth.’</p>
<p>‘Did your father tell you about this?’</p>
<p>‘Sure. He told me all sorts of things.’</p>
<p>‘About the work he did against organized crime?’</p>
<p>‘Yes.’</p>
<p>‘You want to tell me about that? Tell me about The Cigar?’</p>
<p>‘What’s to tell?’</p>
<p>‘Whatever you like.’</p>
<p>‘I’ll tell you something about the famous John Parrish. How about that? How about we go straight to the jugular if that’s what you really, really want.’</p>
<p>‘Yes.’</p>
<p>‘My father was a badass, through and through—’</p>
<p>‘To you?’</p>
<p>‘To pretty much everyone.’</p>
</a><p><a id="page-23"></a><a id="page-24">‘He’s dead now, right? When did he die?’</a></p><a id="page-24">
<p>‘Sixteen years ago. End of September 1992.’</p>
<p>‘And your mother?’</p>
<p>‘She died in January of ’93.’</p>
<p>‘How was their marriage?’</p>
<p>‘He treated her like a princess. He worshipped her.’</p>
<p>‘You have brothers and sisters?’</p>
<p>‘No.’</p>
<p>‘So did he want you to be a police officer?’</p>
<p>‘He wanted me to stay quiet and keep out of the way.’</p>
<p>‘You don’t think he loved you?’</p>
<p>‘He loved me the way all Irish-American fathers love their kids. When I did good he didn’t say a word, when I fucked up he gave me a good thrashing.’</p>
<p>‘And if he were alive now, sitting right here, what would you say to him?’</p>
<p>‘I’d tell him to go fuck himself.’</p>
<p>‘Even though he was a decorated officer?’</p>
<p>‘You checked up on him.’</p>
<p>‘Briefly.’</p>
<p>‘Then why give me the impression you don’t know who the hell I’m talking about?’</p>
<p>‘I need <em>you</em> to talk, Frank, that’s what this is all about.’</p>
<p>‘Oh yeah? If you’re gonna put your cards face-up, then put them face-up. Don’t bullshit me. Say, “Hey, Frank, your father was some big dick on campus wasn’t he? He got Christ-only-knows how many citations, and by the time he was gunned down in the fucking street the Mayor of New York was all set to give him the Congressional Medal of Honor.” Tell me that. Tell me what you know, and then I can fill in the gaps. If we’re gonna get up close and personal here, Doctor Griffin – Marie – then we might as well be playing in the same freakin’ ballpark.’</p>
<p>‘Sure.’</p>
<p>‘Good. So let’s start over.’</p>
</a><p><a id="page-24">‘Your father was a decorated cop. He was involved in the Organized Crime Control Bureau and the New York State Organized Crime Task Force. I understand that he was instrumental in some of the most effective investigations into </a><a id="page-25">corruption in the construction industry, waste haulage, JFK, and the fish and garment businesses—’</a></p><a id="page-25">
<p>‘You sound like you read an obituary on Google.’</p>
<p>‘I did.’</p>
<p>‘Well, whatever you might have read didn’t include all the truth. He was a good cop, at least for the most part, and yes, he did all those things they write about. But he did a lot of things that they didn’t write about, and maybe they never will. And those things went with him to his grave.’</p>
<p>‘And are they things that you think people need to know?’</p>
<p>‘God no! Let ’em believe what they want to believe. People have got to have faith in something. You can’t take it all away otherwise we’d all be neck-high in shit.’</p>
<p>‘Do you want to tell me about some of these things?’</p>
<p>‘Why? You wanna hear old war stories from the day? You wanna hear how my father and his buddies kicked the Mafia out of New York in the Eighties? Or do you wanna hear the truth?’</p>
<p>‘The truth?’</p>
<p>‘Sure, the truth. What you read isn’t so much as the tip of the iceberg as a handful of snowflakes.’</p>
<p>‘He wasn’t what they said he was?’</p>
<p>‘My father? Jesus, no. He was anything but.’</p>
<p>‘Do you want to talk about it?’</p>
<p>‘Not today.’</p>
<p>‘Why is that?’</p>
<p>‘’Cause I got to go see the Coroner and get an ID on a dead girl I found, and then I gotta figure out what the fuck Danny Lange was doing in an alleyway with a bullet in his throat.’</p>
<p>‘Well, I’m glad you kept the appointment, Frank.’</p>
<p>‘Hell, Doctor Marie, if I gave up on every girl after the first date I’d never get laid.’</p>
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// chapter006.vue?0b80a2d4